import React, { useState } from 'react'
import { Container, Row, Col } from "reactstrap"
import { Route, Routes } from 'react-router-dom'
import AutomatelyListHeader from "./AutomatelyListHeader"
import AutomationList from "./AutomationList"
import WorkflowBuilder from "./WorkflowBuilder/WorkflowBuilder"
import ExecutionLogsList from "./WorkflowBuilder/ExecutionLogsList"
import ListingTabs from "../Material/ListingTabs"
import { usePathTab } from "../Functions/usePathTab"
import { ROUTES } from "../Layout/routes"
import "./Automately.css"

const AUTOMATION_LISTING_TABS = [
    { id: 'automations', name: 'Automations', iconClassName: 'fa fa-code-fork' },
    { id: 'execution-logs', name: 'Execution Logs', iconClassName: 'fa fa-history' },
]

export default function AutomatelyContainer() {
    return (
        <div className="AutomatelyContainer">
            <Routes>
                <Route path="/new" element={<WorkflowBuilder />} />
                <Route path="/execution-logs" element={<AutomationWorkspace />} />
                <Route path="/:id" element={<WorkflowBuilder />} />
                <Route path="/" element={<AutomationWorkspace />} />
            </Routes>
        </div>
    )
}

const AutomationWorkspace = () => {
    const { activeTabId: activeTab, changeTab } = usePathTab(ROUTES.automations)
    const [automationSearchTerm, setAutomationSearchTerm] = useState('')
    const [executionLogSearchTerm, setExecutionLogSearchTerm] = useState('')
    const activeSearchTerm = activeTab === 'automations' ? automationSearchTerm : executionLogSearchTerm
    const setActiveSearchTerm = activeTab === 'automations' ? setAutomationSearchTerm : setExecutionLogSearchTerm

    return (
        <Container fluid className="bos-listing-container automately-list-page">
            <ListingTabs
                tabs={AUTOMATION_LISTING_TABS}
                activeTab={activeTab}
                onChange={changeTab}
            />
            <AutomatelyListHeader
                activeTab={activeTab}
                searchTerm={activeSearchTerm}
                setSearchTerm={setActiveSearchTerm}
            />
            <Row className="automately-list-row">
                <Col sm="12">
                    {activeTab === 'automations' ? (
                        <AutomationList searchTerm={automationSearchTerm} />
                    ) : (
                        <ExecutionLogsList showAutomation embedded searchTerm={executionLogSearchTerm} />
                    )}
                </Col>
            </Row>
        </Container>
    )
}
